export function SetLoadingStatus(message: string, failed = false): void {
  if (typeof document === 'undefined') return;
  const status = document.getElementById('loading-status');
  if (!status) return;
  status.hidden = !message;
  const text = status.querySelector('span');
  if (text) text.textContent = message;
  const retry = status.querySelector('button');
  if (retry) { retry.hidden = !failed; retry.onclick = () => location.reload(); }
}
